<template>
  <div>
    <auth-lock-screen></auth-lock-screen>
    <div class="app-container" :class="{ blur: lock_status }">
      <app-offer-modal
        :visible="isAppOfferModalVisible"
        @hideModal="handleAppOfferModalToggle"
      />
      <router-view />
    </div>
  </div>
</template>

<script>
import AppOfferModal from "@/components/common/AppOfferModal";
import AuthLockScreen from "@/components/common/AuthLockScreen";
import { mapGetters } from "vuex";

export default {
  components: {
    "app-offer-modal": AppOfferModal,
    AuthLockScreen
  },
  data() {
    return {
      isAppOfferModalVisible: false
    };
  },
  computed: {
    ...mapGetters({
      lock_status: "Request_MODULE/_status_code/getStatusCode"
    })
  },
  methods: {
    handleAppOfferModalToggle() {
      this.isAppOfferModalVisible = false;
    }
  }
};
</script>

<style>
@import url("./assets/fonts/Gerbera/stylesheet.css");
@import url("./assets/styles/table.css");
@import url("./assets/styles/button.css");
@import url("./assets/styles/input.css");
@import url("./assets/styles/preloader.css");
@import url("./assets/styles/hide.css");
@import url("./assets/styles/modal.css");
@import url("./assets/styles/chart.css");
@import url("./assets/styles/toast.css");

/* Убираем кнопки "след 7 дней", "пред 7 дней" и т.д. */
.mx-shortcuts-wrapper {
  display: none;
}

* {
  font-family: Arial;

  margin: 0;
  padding: 0;
}

a {
  color: #2e79ef;
}

.app-container {
  transition: 0.3s;
  /* overflow: hidden; */
}
.app-container.blur {
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -ms-filter: blur(5px);
  -o-filter: blur(5px);
  filter: url("data:image/svg+xml;utf8,<svg height='0' xmlns='http://www.w3.org/2000/svg'><filter id='svgBlur' x='-5%' y='-5%' width='110%' height='110%'><feGaussianBlur in='SourceGraphic' stdDeviation='5'/></filter></svg>#svgBlur");
  filter: progid: DXImageTransform.Microsoft.Blur(PixelRadius = '5');
  filter: blur(5px);
  transform: scale(1.1);
}

.row {
  display: flex;
}

.row.w100 {
  width: 100%;
}

.row.align-center {
  align-items: center;
}

.row.align-end {
  align-items: flex-end;
}

.row.justify-between {
  justify-content: space-between;
}

.row.row.justify-around {
  justify-content: space-around;
}

.row.justify-end {
  justify-content: flex-end;
}
</style>
